export const WALLET_CURRENCY_MIN_LENGTH = 3;
export const WALLET_CURRENCY_MAX_LENGTH = 4;
